export default "__VITE_ASSET__TdghIB2K__"